import { APIClient } from "../helpers/api_helper";
import * as url from "../helpers/url_helper";
import { RoleItem } from "../interfaces/Role";
import { RolesResponse } from "../slices/roles/types";

const api = new APIClient();

// Check if we should use the fake backend
export const getAllRoles = (
    pageNumber: number = 1,
    pageSize: number = 50
): Promise<RolesResponse> => {
    
    // Real API call with query parameters - using Profile endpoint
    return api.get(url.GET_ROLES, {
        pageNumber,
        pageSize,
    }) as unknown as Promise<RolesResponse>;
};

export const createRole = (data: Partial<RoleItem>): Promise<RoleItem> => {
    
    return api.create(url.POST_ROLE, data) as unknown as Promise<RoleItem>;
};

export const updateRole = (
    id: string,
    data: Partial<RoleItem>
): Promise<RoleItem> => {
    
    return api.put(url.PUT_ROLE + "/" + id, data) as unknown as Promise<RoleItem>;
};

export const deleteRole = (id: string): Promise<void> => {
    
    return api.delete(url.DELETE_ROLE + "/" + id) as unknown as Promise<void>;
};